<template>
  <div class='divide-y border-b' v-if='props.state.themes'>
    <div class='p-4'>
      <SearchInput v-model='state.search' />
    </div>
    <details v-for="theme in filteredList" :key="themeCollection.getId(theme)" class='text-sm' open>
      <summary class='p-4 flex items-center bg-jananavy-50'>
        <div class='flex items-center justify-between w-full pl-1'>
          <strong class='font-medium'>{{ themeCollection.getName(theme) }}</strong>
          <CheckCircleIcon class='w-5 h-5' v-if='isThemeCompleted(theme)' />
        </div>
      </summary>
      <div class='divide-y border-t'>
        <button type='button' class='flex items-center gap-4 pl-12 pr-4 py-3 justify-between hover:bg-gray-50 w-full text-left' :class='isSelectedResponse(response) ? "bg-gray-100 hover:bg-gray-100" : ""' v-for="response in theme.responses" :key="objectiveCollection.getId(response.objective)" @click='selectResponse(response)'>
          <span>{{ objectiveCollection.getName(response.objective) }}</span>
          <span class='flex items-center gap-2'>
            <DocumentCheckIcon class='w-5 h-5' v-if='responseHasNotes(response)' />
            <div class='rounded-full items-center justify-center flex w-20 h-5 text-xs font-medium' :class='[scoreMap.getColour(response.score, "bg"), scoreMap.getColour(response.score, "bg", "text")]' v-if='responseHasScore(response)'>
              {{ scoreMap.getLabel(response.score) }}
            </div>
          </span>
        </button>
      </div>
    </details>
  </div>
</template>

<script setup>

import { computed, reactive } from 'vue';

import {
  DocumentCheckIcon
} from '@heroicons/vue/24/outline';

import {
  CheckCircleIcon
} from '@heroicons/vue/24/solid';

import { getCollection } from '@/kernel/collections';
import { scoreMap } from '@/kernel/scoring';

import SearchInput from '@/components/inputs/search-input.vue';

const themeCollection = getCollection('theme');
const objectiveCollection = getCollection('objective');

const props = defineProps({
  state: Object
});

const state = reactive({
  search: null
});

const selectResponse = (response) => {
  props.state.response = response;
  props.state.drawerOpen = false;
}

const isSelectedResponse = (response) => {
  return objectiveCollection.getId(props.state.response?.objective) === objectiveCollection.getId(response.objective);
}

const isThemeCompleted = (theme) => {
  const completed = theme.responses.filter(response => response.score !== null && response.notes !== null);
  return completed.length === theme.responses.length;
}

const responseHasNotes = (response) => {
  return response.notes?.trim().length;
}

const responseHasScore = (response) => {
  return response.score !== null;
}

const filteredList = computed(() => {
  let themes;
  
  if (!state.search) {
    themes = props.state.themes;
  } else {
    themes = props.state.themes.map(theme => ({...theme}));
    
    themes.forEach((theme) => {
      theme.responses = theme.responses.filter((response) => {
        return response.objective.name.toLowerCase().includes(state.search.toLowerCase());
      });
    });
    
    themes = themes.filter(theme => theme.responses.length > 0);
  }
  
  themes.forEach((theme) => {
    theme.responses.sort((a, b) => {
      return a.objective.name.localeCompare(b.objective.name);
    });
  });
  
  themes.sort((a, b) => {
    return a.name.localeCompare(b.name);
  });
  
  return themes;
});

</script>